import React from 'react'
import { connect } from 'react-redux'
import { fetchSubsidiaries } from '../../actions/subsidiary-actions'
import { Grid, Row, Table } from 'react-bootstrap'

import Breadcrumbs from '../../components/Breadcrumbs'

class SubsidiaryOverview extends React.Component {

  componentDidMount() {
    this.props.fetchSubsidiaries()
  }

  render() {
    const { subsidiaries } = this.props

    return <Grid>
      <Breadcrumbs/>

      <Row>
        <div className='tablescontainer'>
        { subsidiaries.length > 0 ? <Table striped id='subsidiaries'>
            <thead>
              <tr>
                <th>Naam</th>
              </tr>
            </thead>
            <tbody>
              { subsidiaries.map((subsidiary, index) =>
                <tr key={index} onClick={() => this.props.history.push(`/werkmaatschappijen/${subsidiary.id}`)}>
                  <td className='name'>{subsidiary.name}</td>
                </tr>
              )}
            </tbody>
          </Table>
        : <p>Geen resultaten.</p> }
        </div>
      </Row>
    </Grid>
  }
}

export default connect((state) => { return { subsidiaries: state.subsidiaries.all }}, {
  fetchSubsidiaries
})(SubsidiaryOverview)
